import { useMemo } from 'react';

import { type Props as PermissionsProps, usePermissions } from './use-permissions.hook';

export const createWebhookPermissions = (permissions: ReturnType<typeof usePermissions>) => {
	const { hasAnyPermission, useWebhooks } = permissions;

	// Legacy `hasWebhookPermission`: every webhook action, read included, needs WEBHOOKS_ADMIN on a plan with webhooks.
	const canAdmin = () => !!useWebhooks && hasAnyPermission('WEBHOOKS_ADMIN');

	return {
		canRead: canAdmin,
		canCreate: canAdmin,
		canUpdate: canAdmin,
		canDelete: canAdmin,
	};
};

export const useWebhookPermissions = (props: PermissionsProps) => {
	const permissions = usePermissions(props);

	return useMemo(() => createWebhookPermissions(permissions), [permissions]);
};
